import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  Expenses,
  AddExpense,
  ExpenseDetails,
  ExpenseFields,
  ListExpensePolicies,
  EditExpensePolicies,
  DeleteExpensePolicies,
  CreateExpensePolicies,
  ShowExpensePolicies,
  ExpenseComments,
  DeleteExpense,
  ExpenseFiles,
} from "./expenses";

export function getExpenses(req) {
  return sagaFunctions(Expenses, "get", apis.userTransactions, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}
export function getExpenseComments(req) {
  return sagaFunctions(
    ExpenseComments,
    "get",
    apis.expenseComments,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

export function addExpenses(req) {
  if (req.payload.isBulk) {
    return sagaFunctions(
      AddExpense,
      "post",
      apis.bulk_expenses,
      req.payload.vals,
    )();
  } else {
    let formData = new FormData();
    req.payload?.field_values?.forEach((ele, i) => {
      formData.append(`field_values[${i}].id`, ele.id);
      formData.append(`field_values[${i}].value`, ele.value);
    });
    req.payload?.files?.forEach((ele, i) => {
      ele && formData.append(`files[${i}]`, ele);
    });
    req.payload?.delete_file_ids?.forEach((ele, i) => {
      ele && formData.append(`delete_file_ids[]`, ele);
    });
    const url = req.payload?.id
      ? apis.userUpdateTransactions +
        `?id=${req.payload?.id}&merchant_name=${req.payload?.merchant_name}`
      : apis.userTransactions + `?merchant_name=${req.payload?.merchant_name}`;

    return sagaFunctions(AddExpense, "post", url, formData, {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    })();
  }
}

export function getExpenseDetails(req) {
  return sagaFunctions(
    ExpenseDetails,
    "get",
    apis.userTransactions,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

export function getExpensePolicies(req) {
  return sagaFunctions(
    ListExpensePolicies,
    "get",
    apis.list_expense_policies,
    null,
    { skipSuccessMessage: true },
  )();
}

export function createExpensePolicies(req) {
  return sagaFunctions(
    CreateExpensePolicies,
    "post",
    apis.create_expense_policy,
    req.payload,
  )();
}

export function deleteExpensePolicies(req) {
  return sagaFunctions(
    DeleteExpensePolicies,
    "post",
    apis.delete_expense_policy + "?id=" + req.payload.id,
  )();
}

export function deleteExpense(req) {
  let unlink = req.payload.unlink;
  let trip = req.payload.trip;
  let advance = req.payload.advance;
  delete req.payload.unlink;
  delete req.payload.trip;
  delete req.payload.advance;
  let url = unlink ? apis.transactionsUnlink : apis.deleteTransactions;
  if (advance) {
    url = apis.unlinkAdvance;
  }
  if (trip) {
    url = apis.unlinkTrips;
  }
  return sagaFunctions(DeleteExpense, "post", url, req.payload)();
}

export function editExpensePolicies(req) {
  return sagaFunctions(
    EditExpensePolicies,
    "post",
    apis.edit_expense_policy,
    req.payload,
  )();
}

export function showExpensePolicies(req) {
  return sagaFunctions(
    ShowExpensePolicies,
    "get",
    apis.show_expense_policy,
    req.payload,
  )();
}

export function getExpenseFields(req) {
  return sagaFunctions(
    ExpenseFields,
    "get",
    apis.userTransactionsFields,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

export function getExpenseFiles(req) {
  return sagaFunctions(ExpenseFiles, "get", apis.txnsAttachments, req.payload, {
    skipSuccessMessage: true,
  })();
}

export function* expensesWatcher() {
  yield takeLatest(Expenses.REQUEST, getExpenses);
  yield takeLatest(ExpenseComments.REQUEST, getExpenseComments);
  yield takeLatest(AddExpense.REQUEST, addExpenses);
  yield takeLatest(ExpenseDetails.REQUEST, getExpenseDetails);
  yield takeLatest(ExpenseFields.REQUEST, getExpenseFields);
  yield takeLatest(ExpenseFiles.REQUEST, getExpenseFiles);
  yield takeLatest(CreateExpensePolicies.REQUEST, createExpensePolicies);
  yield takeLatest(DeleteExpensePolicies.REQUEST, deleteExpensePolicies);
  yield takeLatest(DeleteExpense.REQUEST, deleteExpense);
  yield takeLatest(EditExpensePolicies.REQUEST, editExpensePolicies);
  yield takeLatest(ShowExpensePolicies.REQUEST, showExpensePolicies);
  yield takeLatest(ListExpensePolicies.REQUEST, getExpensePolicies);
}
